import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { ReportJobStatusEnum } from '../enums/report-job-status.enum';

/**
 * Report job DTO for records
 */
@CaslSubject(AppSubjectEnum.REPORT_JOB)
export class ReportJobRecordDto extends BaseDto {
	reportId!: number;
	queuedAt!: Date;
	completedAt?: Date;
	status!: ReportJobStatusEnum;
	statusMessage?: string;
	file?: FileDto;
}
